export const baseURL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3002';

// export const baseURL = 'https://api.padataapi.com';
